/** 제품명 표기: kord + AI(강조) */
export default function BrandMark({ className = '' }) {
  return (
    <span className={['brand-mark', className].filter(Boolean).join(' ')}>
      kord<span className="brand-mark-ai">AI</span>
    </span>
  )
}
